import { WEB_SHOW_DISCOUNT_LABEL } from "../constants";
import getFeatures from "./getFeatures";

const getShowDiscountLabel = state => {
  const { [WEB_SHOW_DISCOUNT_LABEL]: showDiscountLabel } = getFeatures(state);

  return !!showDiscountLabel;
};

export default getShowDiscountLabel;
